/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {ASSET_ERROR} from '../common/constants/resource-constants';
import {AdnHttpProgressCallback} from '../../components/util/adn-http.service';
import {createAdnUploadFormData} from '../../components/util/adn-http.service';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface FieldMappingModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class FieldMappingApiService extends SignalAdminResourceApiBase<FieldMappingModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'fieldmappings');
  }

  listAll(): Observable<SignalAdminResourcePage<FieldMappingModel>> {
    return this.client.request<SignalAdminResourcePage<FieldMappingModel>>({
      method: 'GET',
      url: this.resourceUri('fieldmappings'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: 1001
      }
    });
  }

  upload(data: any, uploadType?: string, onProgress?: AdnHttpProgressCallback): Promise<any> {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    return firstValueFrom(this.client.upload({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(uploadType || 'fieldmappings'),
      body: createAdnUploadFormData(data)
    }, onProgress));
  }
}
